// @flow
import * as React from 'react';
import type {FlexibleDatesDesktopMobileProps} from './FlexibleDates';

import FlexibleDatesOption from './FlexibleDatesOption';

import './FlexibleDatesDesktop.less';

export default function FlexibleDatesDesktop({
    title,
    options,
    ...props
}: FlexibleDatesDesktopMobileProps) {
    function renderOptions(type, _options) {
        return _options.map((optionProps) => (
            <FlexibleDatesOption
                key={optionProps.id}
                type={type}
                {...props}
                {...optionProps}
            />
        ));
    }

    return (
        <div className="FlexibleDatesDesktop">
            <p className="FlexibleDatesDesktop__Title">{title}</p>
            <div className="FlexibleDatesDesktop__Container">
                {options.sub && renderOptions('sub', options.sub)}
                {options.add && renderOptions('add', options.add)}
            </div>
        </div>
    );
}
